import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import router from "@/router";
import { debounce } from "lodash";
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  store.dispatch("maintenance_crew/getAll");
  store.dispatch("maintenance/getAll");

  const refListTable = ref(null);
  const toast = useToast();

  const maintenanceCompanyOptions = computed(() => store.getters["maintenance/getSelectedItems"]);
  const maintenanceCompanyFilter = ref(null);

  const tableColumns = [
    { label: "actions.name", key: "actions" },
    { label: "maintenance.crew.description", key: "description", sortable: false },
    { label: "maintenance.crew.leader", key: "leader", sortable: false },
    { label: "maintenance.crew.users", key: "users", sortable: false },
    { label: "maintenance.crew.company", key: "maintenance_company.name", sortable: false }, // Nueva columna para mostrar el nombre de la compañía
    {
      label: 'date.created_at',
      key: 'created_at',
      sortable: true,
      formatter: 'formatDateAssigned'
    },
    {
      label: 'date.updated_at',
      key: 'updated_at',
      sortable: true,
      formatter: 'formatDateAssigned'
    },
  ];

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("maintenance_crew/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        id_maintenance_company: maintenanceCompanyFilter.value, // Filtro de compañía
      })
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch(
    [maintenanceCompanyFilter, currentPage, perPage],
    () => {
      refetchData();
    }
  );

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({});
    const filtersCount = useFilterCounter(filters);
    const buildFilters = () => {
      filters.value = {
        id_maintenance_company: maintenanceCompanyFilter.value
      };
      refetchData();
    }
    const clearSearchFilters = () => {
      maintenanceCompanyFilter.value = null;
      buildFilters();
    }

  return {
    maintenanceCompanyOptions,
    maintenanceCompanyFilter,
    refListTable,
    tableColumns,
    perPage,
    totalList,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    fetchList,
    formatDateAssigned,
    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount,
  };
}
